import { Box, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';

const REASON_QUESTION_ID = 'overall_condition_reason';

const ReasonCallout = () => {
  const { values } = useFormikContext<Record<string, unknown>>();
  const reason = values[REASON_QUESTION_ID];
  if (typeof reason !== 'string' || reason.trim() === '') return null;

  return (
    <Box
      bg="amberLight"
      border="1px solid"
      borderColor="bananaMania"
      borderRadius="12px"
      p={6}
      mb={4}
    >
      <Text fontSize="12px" color="grayDark">
        <Text as="span" fontWeight="700" color="darkGoldenrod">
          You said:
        </Text>{' '}
        "{reason.trim()}" Mark the area that covers it below.
      </Text>
    </Box>
  );
};

export default ReasonCallout;
